import type { AccountNode } from '@taler/api-client'
import { type Locale, resolveLocalized } from '@taler/domain'

export interface HomeAccount {
  readonly name: string
  readonly isMoney: boolean
}

/** Name and whether an account is a money account (asset or liability), keyed by id. */
export function indexHomeAccounts(
  nodes: readonly AccountNode[],
  locale: Locale,
): ReadonlyMap<string, HomeAccount> {
  const index = new Map<string, HomeAccount>()
  const walk = (level: readonly AccountNode[]): void => {
    for (const { account, children } of level) {
      index.set(account.id, {
        name: resolveLocalized(account.names, locale)?.name ?? account.code,
        isMoney: account.accountClass === 'ASSET' || account.accountClass === 'LIABILITY',
      })
      walk(children)
    }
  }
  walk(nodes)
  return index
}
